import React, { type ComponentType } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import type ReactOnRails from 'react-on-rails';
import { queryClient } from './queryClient';

type RegisteredComponents = Parameters<typeof ReactOnRails.register>[0];

// ReactOnRails.register に渡す component を QueryClientProvider で包み、どの React root も同じ client を使うようにする。
// 引数が 2 つの関数は react-on-rails が render function として扱うため、ここには component だけを渡すこと
export function withQueryClient(
  components: RegisteredComponents,
): RegisteredComponents {
  return Object.fromEntries(
    Object.entries(components).map(([name, component]) => {
      const Component = component as ComponentType<object>;
      return [
        name,
        (props: object) => (
          <QueryClientProvider client={queryClient}>
            <Component {...props} />
          </QueryClientProvider>
        ),
      ];
    }),
  );
}
